export default {
  NOTIFICATIONS_ADD: 'NOTIFICATIONS_ADD',
  NOTIFICATIONS_REMOVE: 'NOTIFICATIONS_REMOVE',
}
